import * as React from 'react'
import { Card, CardContent, Grid2 as Grid, IconButton, InputAdornment, MenuItem, TextField } from '@mui/material'
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material'

/**
 * Filters component for displaying search input and other options
 */
const Filters = ({ filters, setFilters }) => {
  // Handles form changes
  const handleChange = (e) => {
    const { name, value } = e.target

    setFilters(prev => ({ ...prev, [name]: value }))
  }

  // Clear search field
  const clearSearch = () => {
    setFilters(prev => ({ ...prev, search: '' }))
  }

  return (
    <Card variant="outlined" sx={{ my: 6, displayPrint: 'none' }}>
      <CardContent sx={{ py: 4, px: 3 }}>
        <Grid container spacing={3}>
          <Grid size={10}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: filters.search && (
                    <InputAdornment position="end">
                      <IconButton disableRipple edge="end" onClick={clearSearch}>
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
              placeholder="Search..."
              name="search"
              value={filters.search}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={2}>
            <TextField select fullWidth variant="outlined" size="small" name="status" value={filters.status} onChange={handleChange}>
              <MenuItem value="all">All Status</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default Filters
